var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { baseApi } from "../api/baseApi";
export const costComponentsApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getCostComponents: builder.query({
            query: ({ companyId, externalId, configMonth, projectNumber, childProjectNumber }) => ({
                url: "costcomponents",
                params: { companyId, externalId, configMonth, projectNumber, childProjectNumber },
            }),
            providesTags: (result) => result
                ? [
                    ...result.map(({ id }) => ({ type: "CostComponents", id })),
                    { type: "CostComponents", id: "LIST" },
                ]
                : [{ type: "CostComponents", id: "LIST" }],
        }),
        getCostComponentById: builder.query({
            query: (id) => ({
                url: `costcomponents/${id}`,
            }),
            providesTags: (_result, _error, id) => [
                { type: "CostComponents", id },
            ],
        }),
        createCostComponent: builder.mutation({
            query: (body) => ({
                url: "costcomponents",
                method: "POST",
                body,
            }),
            invalidatesTags: ["CostComponents"],
        }),
        updateCostComponent: builder.mutation({
            query: (_a) => {
                var { id } = _a, body = __rest(_a, ["id"]);
                return ({
                    url: `costcomponents/${id}`,
                    method: "PUT",
                    body,
                });
            },
            invalidatesTags: (_result, _error, { id }) => [
                { type: "CostComponents", id },
            ],
        }),
        deleteCostComponent: builder.mutation({
            query: ({ id, modifiedBy }) => ({
                url: `costcomponents/${id}`,
                method: "DELETE",
                body: { modifiedBy },
            }),
            invalidatesTags: (_result, _error, { id }) => [
                { type: "CostComponents", id },
            ],
        }),
    }),
});
export const { useGetCostComponentsQuery, useGetCostComponentByIdQuery, useLazyGetCostComponentByIdQuery, useCreateCostComponentMutation, useUpdateCostComponentMutation, useDeleteCostComponentMutation, } = costComponentsApi;
